<template>
  <div
    v-if="open"
    class="fixed inset-x-0 top-[58px] z-10 flex items-center justify-center bg-gray-900 px-10 py-2 text-sm text-white"
  >
    <span class="mx-auto text-center">{{ banner.text }}</span>
    <button class="absolute right-3 text-white/80 hover:text-white" @click="dismiss" aria-label="Dismiss banner">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BannerStrip',
  props: {
    banner: { type: Object, default: null }
  },
  data() {
    return { open: false }
  },
  watch: {
    banner: {
      handler(val) {
        if (val && this.$route.name === 'Selection' && this.isNotSuppressed()) {
          this.open = true
        }
      },
      immediate: true
    },
    '$route.name'() {
      if (this.banner && this.$route.name === 'Selection' && this.isNotSuppressed()) {
        this.open = true
      } else if (this.$route.name !== 'Selection') {
        this.open = false
      }
    }
  },
  methods: {
    isNotSuppressed() {
      if (typeof localStorage === 'undefined') return true
      const expiry = localStorage.getItem('banner_expiry')
      if (!expiry) return true
      return new Date(expiry) <= new Date()
    },
    dismiss() {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('banner_expiry', new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString())
      }
      this.open = false
    }
  }
}
</script>
